import React from "react";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import AllCategories from "../../data/category.json";
import slugify from "../../utils/slugify";

const BestBrowserGames = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-[#00F0FF]">
      <Helmet>
        <title>Best Free Browser Games Online | BrowserArena</title>
        <meta
          name="description"
          content="Play the best browser games online for free! Action, puzzle, strategy & more — no downloads, just instant fun."
        />
        <link rel="canonical" href="https://browserarena.com/best-browser-games" />
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">Best Free Browser Games</h1>
      <p className="mb-4">
        Looking for the best browser games to play online for free? We've got you covered. No downloads, no installs — just click and play instantly.
      </p>
      <p className="mb-4">
        From high-speed racing to strategic puzzles, our collection includes top-rated titles from every genre:
      </p>
      <ul className="list-disc list-inside mb-6">
        <li><strong>Action:</strong> Fight, shoot, and survive in high-octane games.</li>
        <li><strong>Puzzle:</strong> Train your brain with clever, challenging puzzles.</li>
        <li><strong>Racing:</strong> Compete for speed and control on dynamic tracks.</li>
        <li><strong>Arcade:</strong> Classic fun with a modern twist.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-3">Explore by Category</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-8">
        {AllCategories.map((cat) => (
          <Link
            key={cat.id}
            to={`/games/${slugify(cat.title)}`}
            className="group w-28 sm:w-32 flex flex-col items-center justify-center text-center px-2 py-3 rounded-2xl border border-[#00F0FF]/30 bg-[#1a1a2e]/50 backdrop-blur-md hover:border-[#FF007F] transition"
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 overflow-hidden rounded-xl mb-2 bg-[#111122]">
              <img
                src={`/assets/${cat.title}.webp`}
                alt={cat.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                onError={(e) => { e.currentTarget.src = '/assets/All.webp'; }}
                loading="lazy"
              />
            </div>
            <span className="text-sm font-medium text-[#CCF6FF] group-hover:text-[#FF007F]">
              {cat.title}
            </span>
          </Link>
        ))}



      </div>

      <p>
        Discover your next favorite game on <Link to="/" className="underline hover:text-[#FF007F]">BrowserArena</Link> — updated regularly and ready to play!
      </p>
    </div>
  );
};

export default BestBrowserGames;
